export function pageUrl(){
    let url = window.location.pathname.slice(1, -1)
    return url
}